var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.matched),function(item){return _c('el-breadcrumb-item',{attrs:{"to":{path:item.path}}},[_vm._v(_vm._s(item.meta.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }